var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteCheck(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.55018 9.15L14.0252 0.675C14.2252 0.475 14.4585 0.375 14.7252 0.375C14.9918 0.375 15.2252 0.475 15.4252 0.675C15.6252 0.875 15.7252 1.11267 15.7252 1.388C15.7252 1.66333 15.6252 1.90067 15.4252 2.1L6.25018 11.3C6.05018 11.5 5.81685 11.6 5.55018 11.6C5.28351 11.6 5.05018 11.5 4.85018 11.3L0.55018 7C0.35018 6.8 0.25418 6.56267 0.26218 6.288C0.27018 6.01333 0.374513 5.77567 0.57518 5.575C0.775847 5.37433 1.01351 5.27433 1.28818 5.275C1.56285 5.27567 1.80018 5.37567 2.00018 5.575L5.55018 9.15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCheck);
export default __webpack_public_path__ + "static/media/white_check.f3b88033a17163c3cd5056ee533dbe4b.svg";
export { ForwardRef as ReactComponent };